/**
 * SearchStack
 * Zoeken, zoeken, zoeken...
 */

import React from 'react';
import {createNativeStackNavigator} from '@react-navigation/native-stack';
import {useTranslation} from 'react-i18next';
import {
  SearchScreen,
  ProductDetailScreen,
  AlternativesScreen,
} from '../screens';
import type {SearchStackParamList} from '../models/Navigation';

const Stack = createNativeStackNavigator<SearchStackParamList>();

export const SearchStackNavigator: React.FC = () => {
  const {t} = useTranslation();

  return (
    <Stack.Navigator id={undefined}>
      <Stack.Screen
        name="Search"
        component={SearchScreen}
        options={{
          title: t('search.title') || 'Zoeken',
          headerShown: true,
        }}
      />
      <Stack.Screen
        name="ProductDetail"
        component={ProductDetailScreen}
        options={{
          title: t('product.title') || 'Product',
          headerShown: false,
        }}
      />
      <Stack.Screen
        name="Alternatives"
        component={AlternativesScreen}
        options={{
          title: t('alternatives.title') || 'Alternatieven',
          headerShown: true,
        }}
      />
    </Stack.Navigator>
  );
};
